import { render, staticRenderFns } from "./sales_performance_dashboard.vue?vue&type=template&id=566de3ef&scoped=true&"
import script from "./sales_performance_dashboard.vue?vue&type=script&lang=js&"
export * from "./sales_performance_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./sales_performance_dashboard.vue?vue&type=style&index=0&id=566de3ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566de3ef",
  null
  
)

export default component.exports